import { getUrl } from 'helpers';
import styled from 'styled-components';

export const FunnelConversionContainer = styled.div<FunnelConversionContainerProps>`
    align-items: center;
    background-position: center;
    background: no-repeat url(${() => getUrl('/assets/images/conversion_bg.svg')});
    display: flex;
    flex-direction: column;
    height: ${({ $compact }) => $compact ? '30px' : '60px' };
    justify-content: center;
    position: relative;
    width: 240px;
`;